module.exports = __webpack_public_path__ + "static/media/monthlycalendar.3308fecf.svg";